module.exports = __webpack_public_path__ + "static/media/eye11.6e8ffe2d.jpeg";